import { FIXED_IN, AFFECTS } from '../../model/system-field.tsx';
import type { FieldCollection } from '../../model/types.tsx';
import type {
	RelatedIssueCountResponse,
	CustomFieldIssueCount,
} from '../../rest/related-issues/types.tsx';

const affectsFieldCount = (issueCount: number): FieldCollection => ({
	[AFFECTS.id]: {
		field: AFFECTS,
		issueCount,
	},
});

const fixedInFieldCount = (issueCount: number): FieldCollection => ({
	[FIXED_IN.id]: {
		field: FIXED_IN,
		issueCount,
	},
});

const customFieldsCount = (customFields: CustomFieldIssueCount[]): FieldCollection =>
	Object.assign(
		{},
		...customFields.map(({ fieldName, customFieldId, issueCountWithVersionInCustomField }) => ({
			[customFieldId]: {
				field: {
					name: fieldName,
					id: customFieldId,
				},
				issueCount: issueCountWithVersionInCustomField,
			},
		})),
	);
export const transformRelatedIssueCountsResponse = (
	response: RelatedIssueCountResponse,
): FieldCollection => ({
	...(response.issuesAffectedCount > 0 ? affectsFieldCount(response.issuesAffectedCount) : {}),
	...(response.issuesFixedCount > 0 ? fixedInFieldCount(response.issuesFixedCount) : {}),
	...(response.issueCountWithCustomFieldsShowingVersion > 0 && response.customFieldUsage
		? customFieldsCount(response.customFieldUsage)
		: {}),
});
